<template>
  <div class="basket">
      <div class="basket__title">
        <h1>Корзина</h1>
      </div>
      <div class="basket__list__block">
        <div class="basket__clear" v-if="CART.length == 0">
            <p>
                Ваша карзина пуста <router-link to="/" tag="a">перейти к покупкам</router-link>
            </p>
        </div>
        <div class="basket__list__block_item">
            <CartItem  
                v-for="(item, index) in CART"
                :key="item.id"
                :cart_data_item="item" 
                @deleteFromCart="deleteFromCart(index)"
                @decrementPrice="decrementPrice(index)"
                @incrementPrice="incrementPrice(index)"
                @quantityChange="quantityChange(index)"
            />
        </div>
        
        <div class="all__price" v-if="CART.length != 0">
            <p>Общая сумма товаров <b>{{cartTotalPrice | numeral('0,0')}}</b> ₸</p>
        </div>
        <div v-if="USER.length != 0 && CART.length != 0" @click="newOrder" class="send_order_main">
             <button>Оформить заказ</button>
        </div>
        <div v-if="USER.length == 0 && CART.length != 0" @click="openForm" class="send_order_main">
             <button>Оформить заказ</button>
        </div>
      </div>
  </div>
</template>

<script>
import CartItem from '@/components/CartItem'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'basket',
  components: {
      CartItem
  },
  methods: {
    ...mapActions([
        'DELETE_FROM_CART',
        'DECREMENT_PRICE',
        'INCREMENT_PRICE'
    ]),
    openForm() {
        this.$emit('openForm')
        document.querySelector('.modal').style.display = 'block'
    },
     deleteFromCart(index) {
        this.DELETE_FROM_CART(index)
     },
     decrementPrice(index) {
         this.DECREMENT_PRICE(index)
     },
     incrementPrice(index) {
         this.INCREMENT_PRICE(index)
     },
     quantityChange(index) {
         console.log(index)
     },
     newOrder() {
        this.$router.replace({ path: '/neworder' }) 
     }
  },
  computed: {
      ...mapGetters(['CART', 'USER']),
      cartTotalPrice() {
        let total = 0;
        for (let item of this.CART) {
            total += item.price;
        }
        return total;
      }
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;

.basket {
    width: 1200px;
    margin: 0 auto;
    background: white;
    overflow: hidden;
    @media (max-width: @baseMedia) {
        width: 95%;
    }
    .send_order_main {
        width: 100%;
        button {
            padding: 20px 0px;
            width: 100%;
            background: #668800;
            color: #fff;
            text-transform: uppercase;
            font-size: 19px;
            font-weight: bold;
            outline: none;
            &:hover {
                opacity: 0.7;
            }
        }
    }
    .basket__title {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        @media (max-width: @baseMedia) {
            padding-top: 10px;
            padding-bottom: 10px;
        }
        h1 {
            color: #4a4a4a;
            font-size: 30px;
            @media (max-width: @baseMedia) {
                font-size: 20px;
            }
        }
    }
    .basket__clear {
        width: 100%;
        height: 350px;
        display: flex;
        justify-content: center;
        align-items: center;
        @media (max-width: @baseMedia) {
            text-align: center;
        }
        p {
            color: #4a4a4a;
            font-size: 30px;
            @media (max-width: @baseMedia) {
                font-size: 19px;
            }
            a {
                color: #000;
            }
        }
    }
    .basket__list__block_item {
        width: 100%;
        height: 60vh;
        overflow-y: scroll;
    }
    .basket__list__block_item::-webkit-scrollbar-track
    {
        background-color: transparent;
    }

    .basket__list__block_item::-webkit-scrollbar
    {
        width: 10px;
    }

    .basket__list__block_item::-webkit-scrollbar-thumb
    {
        border-radius: 2px;
        background-color: #680;
    }
    .all__price {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        background: #f5f5f5;
        p {
            font-size: 20px;
            @media (max-width: @baseMedia) {
                font-size: 16px;
            }
        }
    }
}
</style>